import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, catchError, exhaustMap } from 'rxjs/operators';

import { of } from 'rxjs';
import * as formActions from '@appStore/selfservice/actions';
import { FormsActionTypes } from '@appStore/selfservice/actions';
import { FormsService } from '@appStore/selfservice/services/forms.service';

@Injectable()
export class FormsEffects {
  constructor(private formsService: FormsService, private actions$: Actions) {}


  loadFormCategoriesData$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(FormsActionTypes.LoadFormCategoriesData),
      exhaustMap(action => {
        return this.formsService.getFormCategoriesWithInfo().pipe(
          map(formCategories => new formActions.LoadFormCategoriesSuccess(formCategories)),
          catchError(error => of(new formActions.LoadFormCategoriesFail(error)))
        );
      })
    );
  });
}
